import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import AuthShell from "@/layouts/AuthShell";
import { Button, Input, Label, toast } from "@/components/ds";

export default function InternalActivate() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8 || password !== confirm) { toast.error("Passwords must match and be 8+ characters"); return; }
    setBusy(true);
    try {
      await api.internalActivate({ token, password, first_name: firstName, last_name: lastName });
      toast.success("Account activated — please sign in.");
      navigate("/login");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell title="Activate your ResFil Internal account" subtitle="Set your own password to access the internal portal.">
      {!token ? (
        <p className="text-sm text-red-600" data-testid="activate-no-token">This activation link is missing its token. Please use the link from your invitation email.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="internal-activate-form">
          <div className="flex justify-center"><ShieldCheck className="h-9 w-9 text-blue-600" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>First name</Label><Input value={firstName} onChange={(e) => setFirstName(e.target.value)} data-testid="activate-first" /></div>
            <div><Label>Last name</Label><Input value={lastName} onChange={(e) => setLastName(e.target.value)} data-testid="activate-last" /></div>
          </div>
          <div><Label>Create password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="activate-password" /></div>
          <div><Label>Confirm password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="activate-confirm" /></div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="activate-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Activate account
          </Button>
        </form>
      )}
      <div className="mt-4 text-center text-sm"><Link to="/login" className="text-blue-600">Back to sign in</Link></div>
    </AuthShell>
  );
}
